// extracted by mini-css-extract-plugin
export var bounce = "_p5-1";
export var generatingText = "_p5-6";
export var lightning = "_p5-4";
export var popup = "_p5-5";
export var progressBar = "_p5-7";
export var progressFill = "_p5-8";
export var progressShimmer = "_p5-9";
export var progressText = "_p5-a";
export var shimmer = "_p5-3";
export var uploadIcon = "_p5-0";
export var uploadingText = "_p5-2";